<template>
  <div class="md-layout-item">
    <md-menu class="md-field" md-align-trigger :md-active.sync="showMenu">
      <div class>
        <div class="md-layout-item md-gutter md-layout">
          <md-chip
            class="md-margin-bt"
            @md-delete="deleteChip(index)"
            md-clickable
            md-deletable
            v-bind:key="chip.id"
            v-for="(chip, index) in chips_list"
          >{{chip.name}}</md-chip>
        </div>
        <div>
          <md-autocomplete
            :class="classMessage"
            v-model="value"
            :md-options="terms_list"
            @md-selected="setTag"
            @md-changed="getTerms"
            @md-opened="getTerms"
          >
            <label>{{ label | token_replace(nid) }}</label>
            <span class="md-helper-text">{{ data.help_text | token_replace(nid) }}</span>
            <span class="md-error">*Required.</span>
            <template slot="md-autocomplete-item" slot-scope="{ item }">{{ item.name }}</template>
          </md-autocomplete>
        </div>
      </div>
      <md-menu-content>
        <md-menu-item>test</md-menu-item>
      </md-menu-content>
    </md-menu>
  </div>
</template>
<script>
export default {
  name: "FbTagView",
  props: ["data", "classMessage", "nid"],
  data() {
    return {
      showMenu: false,
      value: "",
      chips_list: this.data.chips.map(chip => {
        return Object.assign({}, chip);
      }),
      label: this.data.label,
      terms_list: []
    };
  },
  methods: {
    getTerms(searchTerm) {
      if (this.data.vocabulary != "") {
        let self = this;
        this.terms_list = new Promise(resolve => {
          if (!searchTerm) {
            resolve([]);
            return;
          }
          const term = searchTerm.toLowerCase();

          fetch("/jsonapi/taxonomy_term/" + this.data.vocabulary)
            .then(res => {
              return res.json();
            })
            .then(json => {
              resolve(
                json.data
                  .map(el => {
                    return {
                      id: el.attributes.drupal_internal__tid,
                      name: el.attributes.name
                    };
                  })
                  .filter(({ name }) => {
                    return (
                      name.toLowerCase().includes(term) &&
                      self.chips_list.filter(el => {
                        if (el.name.toLowerCase() == name.toLowerCase()) {
                          return el;
                        }
                      }).length === 0
                    );
                  })
              );
            })
            .catch(() => {
              resolve([]);
            });
        });
      }
    },
    setTag(event) {
      let filtered = this.chips_list.filter(el => {
        if (el.id == event.id) {
          return el;
        }
      });
      if (filtered.length) {
        this.value = "";
        window.setTimeout(() => {
          this.value = "";
        }, 0);
        return;
      }
      this.chips_list.push(event);
      this.value = event.name;
      window.setTimeout(() => {
        this.value = "";
      }, 100);
      this.$emit("change", this.chips_list);
    },
    deleteChip(index) {
      this.chips_list.splice(index, 1);
      this.$emit("change", this.chips_list);
    }
  },
  watch: {
    data: function(val) {
      this.chips_list = val.chips.map(option => {
        return Object.assign({}, option);
      });
      this.label = val.label;
      this.terms_list = [];
      this.value = "";
    }
  }
};
</script>
<style lang="scss" scoped>
.md-no-bt-margin {
  margin-bottom: 0;
}
.md-margin-bt {
  margin: 4px 0 4px;
}
.shake-on-error /deep/ .md-duplicated {
  animation-name: shake;
  animation-duration: 0.5s;
}

@keyframes shake {
  0% {
    transform: translate(15px);
  }
  20% {
    transform: translate(-15px);
  }
  40% {
    transform: translate(7px);
  }
  60% {
    transform: translate(-7px);
  }
  80% {
    transform: translate(3px);
  }
  100% {
    transform: translate(0px);
  }
}
</style>
